import { Box, Button, IconButton, InputAdornment, TextField, Typography } from '@mui/material';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useState } from 'react';
import { login } from '../../services/autorization';
import { FormState } from '../../interfaces/user';

interface FormAuthPropsI {
  onSubmitFormAction: (p: FormState) => void;
}

const FormAuth = ({ onSubmitFormAction }: FormAuthPropsI) => {
  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    control,
    reset,
    formState: { errors, isValid },
  } = useForm<FormState>({ mode: 'onBlur', reValidateMode: 'onChange' });

  const requiredValidation = { required: 'Это обязательное поле' };

  const onSubmitForm: SubmitHandler<FormState> = (data: FormState) => {
    onSubmitFormAction(data);
    reset();
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  return (
    <Box component="form" className="form" onSubmit={handleSubmit(onSubmitForm)} data-testid="form">
      <div className="form-wrapper">
        <Typography variant="h6" component="h6" margin="normal" sx={{ m: 4 }}>
          Войдите в систему
        </Typography>
        <Controller
          control={control}
          name="login"
          render={({ field }) => (
            <TextField
              data-testid="InputLogin"
              sx={{ m: 2 }}
              fullWidth
              id="login"
              label="Имя"
              {...register('login', requiredValidation)}
              onChange={(e) => field.onChange(e)}
              variant="outlined"
              helperText={errors?.login?.message || ''}
              error={!!errors?.login}
            />
          )}
        />

        <Controller
          control={control}
          name="password"
          data-testid="InputPassword"
          render={({ field }) => (
            <TextField
              data-testid="InputPassword"
              sx={{ m: 2 }}
              fullWidth
              id="registrationPass"
              label="Пароль"
              {...register('password', requiredValidation)}
              type={showPassword ? 'text' : 'password'}
              // value={field.value}
              onChange={(e) => field.onChange(e)}
              helperText={errors?.password?.message || ''}
              error={!!errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              variant="outlined"
            />
          )}
        />
        <Button
          variant="contained"
          type={'submit'}
          sx={{ m: 2, paddingX: 10 }}
          data-testid="formButton"
        >
          Войти
        </Button>
      </div>
    </Box>
  );
};
export default FormAuth;
